import { render, staticRenderFns } from "./Page07New.vue?vue&type=template&id=fa6c2b5a&scoped=true&"
import script from "./Page07New.vue?vue&type=script&lang=js&"
export * from "./Page07New.vue?vue&type=script&lang=js&"
import style0 from "./Page07New.vue?vue&type=style&index=0&id=fa6c2b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6c2b5a",
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QSpace,QSelect,QCheckbox,QItem,QItemSection,QItemLabel,QToggle,QBtnDropdown,QCard,QCardSection,QInput,QIcon,QSeparator,QCardActions,QBtn,QBtnToggle,QVirtualScroll,QInnerLoading,QSpinnerGears,ClosePopup} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QSpace,QSelect,QCheckbox,QItem,QItemSection,QItemLabel,QToggle,QBtnDropdown,QCard,QCardSection,QInput,QIcon,QSeparator,QCardActions,QBtn,QBtnToggle,QVirtualScroll,QInnerLoading,QSpinnerGears}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
